import axios from '../../../axiosConfig';

export const validarManifiestoActivo = async () => {
    const numeroIdentificacion = localStorage.getItem('idConductor');
    const numeroManifiesto = localStorage.getItem('manifiesto');
    const tenantEmpresa = localStorage.getItem('tenantEmpresa');
    try {
        const response = await axios.get('/validarConductor', {
            params: {
                identificacion: numeroIdentificacion,
                manifiesto: numeroManifiesto,
                tenantEmpresa: tenantEmpresa
            },
            validateStatus: (status) => status >= 200 && status < 500
        });
        return Boolean(response.data && response.data.tokenOperacion);
    } catch {
        return false;
    }
};
